import styled from '@emotion/styled'
import * as React from 'react'

import { IDesiredWeeklyScheduleParams } from 'main/components/family/DesiredWeeklyScheduleFields'
import { IChild } from 'main/gql/child'
import { NativeLink, spacing, Strong, Text, typography } from 'main/ui'
import { formatTime } from 'main/util/time'
import { TFunction, useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../common'
import { i18nKeyPrefix } from '../../../../i18n'
import ChildDetails from './ChildDetails'

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-REVIEW-DETAILS`

interface IProps {
  desiredWeeklyScheduleParams: IDesiredWeeklyScheduleParams
  selectedChildren: IChild[]
  onRequestChange: () => void
}

const Container = styled.div`
  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(1)}px;
  }
`

export default function DetailsReview(props: IProps) {
  const { desiredWeeklyScheduleParams, selectedChildren, onRequestChange } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      <div>
        <Strong>{t(`${PRE}-TITLE`)}</Strong>
        <Text>{formatDesiredWeeklySchedule(desiredWeeklyScheduleParams, t)}</Text>
      </div>

      {selectedChildren.map(child => (
        <ChildDetails key={child.id} child={child} />
      ))}

      <div>
        <NativeLink css={{ fontWeight: typography.fontWeight.bold }} onClick={onRequestChange}>
          {t(`${PRE}-CHANGE`)}
        </NativeLink>
      </div>
    </Container>
  )
}

function formatDesiredWeeklySchedule(params: IDesiredWeeklyScheduleParams, t: TFunction) {
  const { days, dropoffAt, pickupAt } = params
  if (!dropoffAt || !pickupAt) return ''

  const formattedDays = [
    days.monday && t(`${PRE}-MON`),
    days.tuesday && t(`${PRE}-TUE`),
    days.wednesday && t(`${PRE}-WED`),
    days.thursday && t(`${PRE}-THU`),
    days.friday && t(`${PRE}-FRI`),
  ]
    .filter(Boolean)
    .join(', ')

  return `${formattedDays}, ${formatTime(dropoffAt)} - ${formatTime(pickupAt)}`
}
